import {
  ChangePersonRegister,
  ChangePersonReplace,
  ChangePersonDepartment,
  ChangePersonReason,
  Notes,
} from "./_fields";
import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";

type ChangePersonTemplate = {
  ChangePersonRegister: string;
  ChangePersonReplace: string;
  ChangePersonDepartment: string;
  ChangePersonReason: string;
  Notes: string;
};

export const changePersonTemplate: TemplatesValue<ChangePersonTemplate> = {
  fileName: "ThayDoiBoSungNhanSu",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    ChangePersonRegister,
    ChangePersonReplace,
    ChangePersonDepartment,
    ChangePersonReason,
    Notes
  ],
  fields: [
    "ChangePersonRegister",
    "ChangePersonReplace",
    "ChangePersonDepartment",
    "ChangePersonReason",
    "Notes",
  ],
};
